import React from "react";
import StatusHero from "./StatusHero";
import ShipmentJourney from "./ShipmentJourney";
import ShipmentDetails from "./ShipmentDetails";
import HelpCard from "./HelpCard";
import { getPodLink, getShipmentSummary, hasDeliveredEvent, applyBookingLabels } from "./trackingUtils";

const TrackingDetailsCard = ({ trackingData }) => {
  if (!trackingData) return null;

  const info = trackingData.orderInformation;
  const trackingId = info?.trackingId || trackingData.statuses?.[0]?.trackingId || "Unknown";

  // POD shows once the shipment has been delivered and a POD link exists
  const podLink = hasDeliveredEvent(trackingData.statuses || []) ? getPodLink(info) : null;
  const cityContext = {
    sourceCity: info?.sourceLocation?.city,
    knownCities: [info?.sourceLocation?.city, info?.destinationLocation?.city],
  };
  const statuses = applyBookingLabels(trackingData.statuses || [], info?.type);
  const summary = getShipmentSummary(statuses, cityContext.knownCities);

  return (
    <div className="tracking-details">
      <StatusHero trackingId={trackingId} summary={summary} />
      <div className="tracking-columns">
        <ShipmentJourney
          timeline={summary.timeline}
          tone={summary.tone}
          cityContext={cityContext}
        />
        <div className="side-column">
          <ShipmentDetails info={info} summary={summary} podLink={podLink} />
          <HelpCard />
        </div>
      </div>
    </div>
  );
};

export default TrackingDetailsCard;
